export default "__VITE_ASSET__132b391a__"